import script from "./NbsNotifAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./NbsNotifAlert.vue?vue&type=script&setup=true&lang=js"

import "./NbsNotifAlert.vue?vue&type=style&index=0&id=6f417313&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f417313"]])

export default __exports__